import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ao_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const trackVisit = (page) => {
  api.post(`/track?page=${encodeURIComponent(page)}`).catch(() => {});
};
